import Resizer from "react-image-file-resizer"

export const MAX_IMAGE_WIDTH = 1024
export const IMAGE_MAX_SIZE = 10 * MAX_IMAGE_WIDTH * MAX_IMAGE_WIDTH // 10Mo
export const VIDEO_MAX_SIZE = 30_000_000 // 30Mo
export const DOCUMENT_MAX_SIZE = 50_000_000 // 50Mo

export const readFile = (file: File) =>
  new Promise<string | null>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (event) => {
      const result = event.target?.result
      if (result && typeof result === "string") {
        const [_contentType, content] = result.split(",")
        resolve(content || null)
      } else {
        resolve(null)
      }
    }

    reader.onerror = reject
    reader.readAsDataURL(file)
  })

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
const imageFileResizerFn = (Resizer as any).default?.imageFileResizer as ((...args: any[]) => void) | undefined

export const resizeImage = (file: File): Promise<File> =>
  new Promise((resolve, reject) => {
    if (!imageFileResizerFn) {
      reject(new Error("imageFileResizer is undefined"))
      return
    }

    try {
      imageFileResizerFn(
        file,
        MAX_IMAGE_WIDTH,
        MAX_IMAGE_WIDTH,
        "JPEG",
        100,
        0,
        (uri: unknown) => resolve(uri as File),
        "file",
      )
    } catch (_error) {
      reject(new Error("Failed to resize image"))
    }
  })
